import React, { useState } from "react";
import { auth } from "../firebase";

const NotificationForm = () => {
    const [title, setTitle] = useState("");
    const [body, setBody] = useState("");
    const [token, setToken] = useState(""); 
    const [status, setStatus] = useState("");

    const sendNotification = async () => {
        if (!title.trim() || !body.trim()) {
            setStatus("❌ Please fill in both title and message");
            return;
        }

        setStatus("Sending...");
        try {
            const payload = token
                ? { title, description: body, userId: token }
                : { title, description: body };

            console.log("Sending notification with payload:", payload);

            const user = auth.currentUser;
            if (!user) {
                setStatus("❌ Please log in first");
                return;
            }

            console.log("Current user:", user.email);
            const idToken = await user.getIdToken();
            console.log("ID Token:", idToken.substring(0, 50) + "...");

            const response = await fetch(
                "https://us-central1-local-helperrr.cloudfunctions.net/sendDashboardNotification",
                {
                    method: "POST",
                    headers: { 
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${idToken}`
                    },
                    body: JSON.stringify(payload),
                }
            );

            console.log("Response status:", response.status);
            const data = await response.json();
            console.log("Response data:", data);

            if (response.ok) {
                setStatus("✅ Notification sent successfully!");
                // clear inputs
                setTitle("");
                setBody("");
                setToken("");
            } else {
                setStatus("❌ Failed: " + (data.error || JSON.stringify(data)));
            }
        } catch (err) {
            console.error("Error sending notification:", err);
            setStatus("❌ Error: " + err.message);
        }
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.header}>🚀 Send Notification</h2>

            <input
                type="text"
                placeholder="Notification Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                style={styles.input}
            />

            <textarea
                placeholder="Message Body"
                value={body}
                onChange={(e) => setBody(e.target.value)}
                style={{ ...styles.input, height: 100, resize: "none" }}
            />

            <input
                type="text"
                placeholder="User ID (optional)"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                style={styles.input}
            />

            <button onClick={sendNotification} style={styles.button}>
                Send Notification
            </button>

            {status && <p style={styles.status}>{status}</p>}
        </div>
    );
};

// Styling object
const styles = {
    container: {
        maxWidth: 500,
        margin: "50px auto",
        padding: 30,
        borderRadius: 12,
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        backgroundColor: "#ffffff",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    header: {
        textAlign: "center",
        marginBottom: 20,
        color: "#333",
    },
    input: {
        padding: 12,
        marginBottom: 15,
        borderRadius: 8,
        border: "1px solid #ccc",
        fontSize: 16,
        outline: "none",
    },
    button: {
        padding: 12,
        backgroundColor: "#4caf50",
        color: "#fff",
        fontSize: 16,
        border: "none",
        borderRadius: 8,
        cursor: "pointer",
        transition: "background-color 0.3s",
    },
    status: {
        marginTop: 15,
        fontWeight: "bold",
        textAlign: "center",
    },
};

export default NotificationForm;
